import http from "@/services/http";

/**
 * Pesquisa de CRM e dados de médico por região — salvia-805.
 *
 * Ferramenta interna do time comercial. A fonte é o CNES (base PÚBLICA do
 * DATASUS), carregada no nosso banco por `php artisan cnes:import` — a busca
 * NÃO vai ao BigQuery, então a tela funciona sem credencial de GCP no ambiente.
 *
 * O que o CNES não tem (auditoria da salvia-758): CPF, telefone, e-mail e
 * endereço do médico. A tela qualifica o alvo; não entrega o contato dele.
 */

/**
 * Busca médicos no snapshot do CNES.
 *
 * @param {Object} filtros
 * @param {string} [filtros.crm]
 * @param {string} [filtros.uf]
 * @param {string} [filtros.nome]
 * @param {string} [filtros.municipio]      nome do município ("Campinas")
 * @param {string} [filtros.regiao]
 * @param {string} [filtros.nivel_regiao]   metropolitana | saude | mesorregiao | macro
 * @param {string} [filtros.especialidade]  ocupação no CBO ("cardiologista")
 * @param {boolean} [filtros.apenas_nao_sus]
 * @param {number} [filtros.page]
 * @param {number} [filtros.por_pagina]
 * @returns {Promise<{medicos: Array, meta: Object, snapshot: string|null}>}
 */
export async function buscarMedicos(filtros = {}) {
  // Campos vazios não viram query string: o backend recusa a busca quando
  // NENHUM filtro vem preenchido, e string vazia não conta como filtro.
  const params = {};
  Object.entries(filtros).forEach(([chave, valor]) => {
    if (valor === null || valor === undefined || valor === "" || valor === false) {
      return;
    }
    // Query string não tem booleano: o axios serializaria `true` como o TEXTO
    // "true", e a regra `boolean` do Laravel aceita 1/0/"1"/"0" mas não "true"
    // — a busca voltava 422 "must be true or false". Manda 1.
    params[chave] = valor === true ? 1 : valor;
  });

  const { data } = await http.get("/api/cnes/doctors", { params });

  return {
    medicos: data?.data || [],
    meta: data?.meta || { total: 0, pagina: 1, ultima: 1 },
    snapshot: data?.snapshot || null,
  };
}

/**
 * Opções dos filtros: UFs e regiões efetivamente carregadas no snapshot.
 *
 * Existe porque a carga é feita por UF — a tela precisa oferecer só o que está
 * no banco, em vez de um Brasil inteiro que talvez não tenha sido importado.
 *
 * @param {string} [uf]
 */
export async function carregarOpcoes(uf) {
  const { data } = await http.get("/api/cnes/options", {
    params: uf ? { uf } : {},
  });

  return data?.data || {
    ufs: [],
    niveis_regiao: [],
    regioes: {},
    snapshot: null,
    total_medicos: 0,
  };
}
